import React from 'react';
import { useParams } from 'react-router-dom';
import { useCatalog } from '../context/CatalogContext';
import { useLang } from '../context/LangContext';
import ProductDetailContent from '../components/ProductDetailContent';
import PageHeader from '../lib/ui/PageHeader';
import { EmptyState } from '../lib/ui/Feedback';

/** Direct-load / refresh of /product/:id — full page, not an overlay. */
export default function ProductDetailPage() {
  const { id } = useParams();
  const { products, loading } = useCatalog();
  const { lang } = useLang();
  const te = lang === 'te';
  const product = products.find((p) => String(p.id) === String(id));

  return (
    <div className="max-w-2xl mx-auto md:mt-6 md:rounded-3xl md:overflow-hidden md:shadow-card md:border md:border-black/5 bg-white">
      <PageHeader title={product?.name_en || (te ? 'ఉత్పత్తి' : 'Product')} />
      {product ? (
        <ProductDetailContent product={product} />
      ) : loading ? (
        <div className="py-16 text-center text-ink-faint">{te ? 'లోడ్ అవుతున్నది…' : 'Loading…'}</div>
      ) : (
        <EmptyState icon="🔍" title={te ? 'ఉత్పత్తి కనబడలేదు' : 'Product not found'} />
      )}
    </div>
  );
}
